import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchPanelUser , setPageSize } from "../../slices/panelUserSlice";
import { fetchMailBox, addMailBox } from "../../slices/mailBoxSlice";
import PanelUserSearch from "@/components/PanelUserSearch";
import SimplePagination from "@/components/SimplePagination";
import PageSizeSelector from "@/components/PageSizeSelector";


function SendEmail() {
  const dispatch = useDispatch();
    const {
      panelUserList,
      currentPage,
      totalPages,
      search,
      pageSize
    } = useSelector((state) => state.panelUser);
  
  const [searchInput, setSearchInput] = useState(search || "");
    
  const [formData, setFormData] = useState({
    title: "",
    body: "",
    surveyId: "",
    link: "",
    selectedUsers: [],
  });

  const [allSelected, setAllSelected] = useState(false);

  const currentUsers = panelUserList?.result || [];

 // ================= API CALLS =================

  // initial load
  useEffect(() => {
    dispatch(fetchPanelUser({ page: 1, search: "" }));
  }, []);

  // debounce search
  useEffect(() => {
    const timer = setTimeout(() => {
      dispatch(fetchPanelUser({ page: 1, search: searchInput }));
    }, 800);

    return () => clearTimeout(timer);
  }, [searchInput]);

  // page change
  useEffect(() => {
    dispatch(fetchPanelUser({ page: currentPage, search: searchInput }));
  }, [currentPage]);


  // Handle input changes
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

   // ================= USER SELECT =================
  
    const handleUserChange = (userId) => {
      setFormData((prev) => {
        const isSelected = prev.selectedUsers.includes(userId);
  
        return {
          ...prev,
          selectedUsers: isSelected
            ? prev.selectedUsers.filter((id) => id !== userId)
            : [...prev.selectedUsers, userId],
        };
      });
    };
  
    // ================= SELECT ALL (PER PAGE) =================
  
    const isAllSelected =
      currentUsers.length > 0 &&
      currentUsers.every((u) =>
        formData.selectedUsers.includes(u.pii)
      );
  
    const isSomeSelected = currentUsers.some((u) =>
      formData.selectedUsers.includes(u.pii)
    );
  
      const handlePageSizeChange = (size) => {
        dispatch(setPageSize(size)); // update slice
        dispatch(fetchPanelUser({ page: 1, search }));
      }; 
    
  
  
    const handleSelectAll = () => {
      const pageIds = currentUsers.map((u) => u.pii);
  
      if (isAllSelected) {
        // remove current page users
        setFormData((prev) => ({
          ...prev,
          selectedUsers: prev.selectedUsers.filter(
            (id) => !pageIds.includes(id)
          ),
        }));
      } else {
        // add current page users
        setFormData((prev) => ({
          ...prev,
          selectedUsers: [
            ...prev.selectedUsers,
            ...pageIds.filter((id) => !prev.selectedUsers.includes(id)),
          ],
        }));
      }
    };


  const handleSubmit = async (e) => {
    e.preventDefault();
    let mailList = formData.selectedUsers.map((elem) => ({
      pii: elem,
      title: formData.title,
      body: formData.body,
      surveyId: formData.surveyId,
      link: formData.link,
    }));

    const finalData = { mailList };
    const resp = await dispatch(addMailBox(finalData));
    if (!resp.error) {
      dispatch(fetchMailBox({ page: 1}));
    }
  };

  return (
    <div className="p-4 mx-auto md:min-w-[600px] bg-white rounded-lg">
      <form onSubmit={handleSubmit} className="space-y-4">
        {/* Grid Layout for 3 Fields */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <label className="block text-gray-700">Title</label>
            <input
              type="text"
              name="title"
              value={formData.title}
              onChange={handleChange}
              className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />
          </div>

          <div>
            <label className="block text-gray-700">Survey Id</label>
            <input
              type="text"
              name="surveyId"
              value={formData.surveyId}
              onChange={handleChange}
              className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />
          </div>

          <div>
            <label className="block text-gray-700">Link</label>
            <input
              type="text"
              name="link"
              value={formData.link}
              onChange={handleChange}
              className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />
          </div>
        </div>

        {/* Body Input */}
        <div>
          <label className="block text-gray-700">Body</label>
          <textarea
            name="body"
            value={formData.body}
            onChange={handleChange}
            rows="2"
            className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none"
            required
          />
        </div>

        {/* Scrollable User Checkbox List with Select All */}
        <div>
          <label className="block text-gray-700 mb-2">Select Users</label>

            {/* SEARCH */}
          <PanelUserSearch
            value={searchInput}
            onChange={setSearchInput}
          />


          <div className="h-40 overflow-y-auto border p-2 rounded-lg">
            {/* Select All Checkbox */}
            <div className="flex items-center space-x-2 p-1 w-full cursor-pointer bg-gray-100 rounded-md">
              <input
                type="checkbox"
                checked={isAllSelected}
                ref={(el) => {
                  if (el)
                    el.indeterminate =
                      !isAllSelected && isSomeSelected;
                }}
                onChange={handleSelectAll}
                // className="w-4 h-4"
              />
              <label htmlFor="select-all" className="text-gray-900 cursor-pointer w-full p-1 font-semibold">
                Select All (This Page)
              </label>
            </div>

              {/* USERS */}
            {currentUsers.length > 0 ? (
              currentUsers.map((user) => (
                <div
                  key={user.pii}
                  className="flex items-center space-x-2 p-1"
                >
                  <input
                    type="checkbox"
                    checked={formData.selectedUsers.includes(user.pii)}
                    onChange={() => handleUserChange(user.pii)}
                  />
                  <label className="cursor-pointer">
                    {user.email}
                  </label>
                </div>
              ))
            ) : (
              <p className="text-gray-500 text-sm">
                No users available
              </p>
            )}
          </div>

            {/* PAGINATION */}
          <div className="mt-3">

             <PageSizeSelector
          pageSize={pageSize}
          setPageSize={handlePageSizeChange}
        />

            <SimplePagination
              currentPage={currentPage}
              setCurrentPage={(page) =>
                dispatch(
                  fetchPanelUser({
                    page,
                    search: searchInput,
                  })
                )
              }
              totalPages={totalPages}
            />
          </div>
        </div>

        {/* Submit Button */}
        <button
          type="submit"
          className="w-full bg-[var(--mainCol)] text-white py-2 rounded-lg hover:bg-[var(--mainCol)] transition"
        >
          Send Invites
        </button>
      </form>
    </div>
  );
}

export default SendEmail;
